import Vue from "vue";
import Router from "vue-router";
import HelloWorld from "@/components/HelloWorld";
import versionUpdate from "../libs/versionUpdate";

Vue.use(Router);

// routes.beforeEach((to, from, next) => {
//   versionUpdate.isNewVersion;
// });

// export default new Router({
const router = new Router({
  routes: [
    {
      path: "/",
      name: "HelloWorld",
      component: HelloWorld
    },
    {
      //访客主页面
      path: "/visitor",
      name: "/visitor",
      component: resolve => require(["../views/mobile/Visitor.vue"], resolve),
      meta: { allowBack: false }
    },
    {
      //访客个人信息页面
      path: "/vpersonal",
      name: "/vpersonal",
      component: resolve => require(["../views/mobile/Vpersonal.vue"], resolve)
    },
    {
      //访客发起预约
      path: "/vreserve",
      name: "/vreserve",
      component: resolve => require(["../views/mobile/Vreserve.vue"], resolve)
    },
    {
      //访客预约凭证列表
      path: "/vrecord",
      name: "/vrecord",
      component: resolve => require(["../views/mobile/Vrecord.vue"], resolve)
    },
    {
      //访客预约凭证详细信息
      path: "/vdetail",
      name: "/vdetail",
      component: resolve => require(["../views/mobile/Vdetail.vue"], resolve)
    },
    {
      //演示来访预约
      path: "/vreserve2",
      name: "/vreserve2",
      component: resolve => require(["../views/mobile/Vreserve2.vue"], resolve)
    },

    {
      //货车人员主页面
      path: "/truck",
      name: "/truck",
      component: resolve => require(["../views/mobile/Truck.vue"], resolve),
      meta: { allowBack: false }
    },
    {
      //
      path: "/tpersonal",
      name: "/tpersonal",
      component: resolve => require(["../views/mobile/Tpersonal.vue"], resolve)
    },
    {
      //
      path: "/treserve",
      name: "/treserve",
      component: resolve => require(["../views/mobile/Treserve.vue"], resolve)
    },
    {
      //
      path: "/trecord",
      name: "/trecord",
      component: resolve => require(["../views/mobile/Trecord.vue"], resolve)
    },
    {
      //
      path: "/tdetail",
      name: "/tdetail",
      component: resolve => require(["../views/mobile/Tdetail.vue"], resolve)
    },

    {
      //
      path: "/StruckInvite",
      name: "/StruckInvite",
      component: resolve =>
        require(["../views/mobile/StruckInvite.vue"], resolve)
    },
    {
      //
      path: "/StruckRecord",
      name: "/StruckRecord",
      component: resolve =>
        require(["../views/mobile/StruckRecord.vue"], resolve)
    },

    {
      //模板消息点击页面
      path: "/scode",
      name: "/scode",
      component: resolve => require(["../views/mobile/Scode.vue"], resolve)
    },
    {
      //模板消息点击页面
      path: "/stcode",
      name: "/stcode",
      component: resolve => require(["../views/mobile/STcode.vue"], resolve)
    },

    {
      //被访人主页面
      path: "/staff",
      name: "/staff",
      component: resolve => require(["../views/mobile/Staff.vue"], resolve)
    },
    {
      //被访人主页面
      path: "/spersonal",
      name: "/spersonal",
      component: resolve => require(["../views/mobile/Spersonal.vue"], resolve)
    },
    {
      //被访人邀请访客
      path: "/sinvite",
      name: "/sinvite",
      component: resolve => require(["../views/mobile/Sinvite.vue"], resolve)
    },
    {
      //被访人预约凭证列表
      path: "/srecord",
      name: "/srecord",
      component: resolve => require(["../views/mobile/Srecord.vue"], resolve)
    },
    {
      //被访人预约凭证详细信息
      path: "/sdetail",
      name: "/sdetail",
      component: resolve => require(["../views/mobile/Sdetail.vue"], resolve)
    },
    {
      //申请放行条主页面
      path: "/Sreleaseindex",
      name: "/Sreleaseindex",
      component: resolve =>
        require(["../views/mobile/Sreleaseindex.vue"], resolve)
    },
    {
      //申请放行条
      path: "/Srelease",
      name: "/Srelease",
      component: resolve => require(["../views/mobile/Srelease.vue"], resolve)
    },
    {
      //放行条记录列表
      path: "/SreleaseRecord",
      name: "/SreleaseRecord",
      component: resolve =>
        require(["../views/mobile/SreleaseRecord.vue"], resolve)
    },
    {
      //
      path: "/SreleaseRecordLeader",
      name: "/SreleaseRecordLeader",
      component: resolve =>
        require(["../views/mobile/SreleaseRecordLeader.vue"], resolve)
    },
    {
      //
      path: "/SreleaseRecordReturn",
      name: "/SreleaseRecordReturn",
      component: resolve =>
        require(["../views/mobile/SreleaseRecordReturn.vue"], resolve)
    },
    {
      //放行条记录详情
      path: "/SreleaseDetail",
      name: "/SreleaseDetail",
      component: resolve =>
        require(["../views/mobile/SreleaseDetail.vue"], resolve)
    },
    // {
    //   //放行条记录详情
    //   path: "/SreleaseDetail2",
    //   name: "/SreleaseDetail2",
    //   component: resolve =>
    //     require(["../views/mobile/SreleaseDetail2.vue"], resolve)
    // },
    {
      //放行条记录列表-当天
      path: "/SreleaseRecordToday",
      name: "/SreleaseRecordToday",
      component: resolve =>
        require(["../views/mobile/SreleaseRecordToday.vue"], resolve)
    },
    {
      //放行条记录详情-当天
      path: "/SreleaseDetailToday",
      name: "/SreleaseDetailToday",
      component: resolve =>
        require(["../views/mobile/SreleaseDetailToday.vue"], resolve)
    },
    {
      //被访人-待审核记录
      path: "/Sundo",
      name: "/Sundo",
      component: resolve => require(["../views/mobile/Sundo.vue"], resolve)
    },

    {
      //货车放行记录列表-当天
      path: "/StruckRecordToday",
      name: "/StruckRecordToday",
      component: resolve =>
        require(["../views/mobile/StruckRecordToday.vue"], resolve)
    },
    {
      //货车放行记录详情-当天
      path: "/StruckDetailToday",
      name: "/StruckDetailToday",
      component: resolve =>
        require(["../views/mobile/StruckDetailToday.vue"], resolve)
    },

    {
      // 考试
      path: "/VKaoShi",
      name: "/VKaoShi",
      component: resolve => require(["../views/mobile/VKaoShi.vue"], resolve),
      meta: { allowBack: false }
    },
    {
      // 观看视频
      path: "/VVideo",
      name: "/VVideo",
      component: resolve => require(["../views/mobile/VVideo.vue"], resolve),
      meta: { allowBack: false }
    },

    {
      // 输入身份证号码验证
      path: "/VInputIdCard",
      name: "/VInputIdCard",
      component: resolve =>
        require(["../views/mobile/VInputIdCard.vue"], resolve),
      meta: { allowBack: false }
    },
    {
      //物品返回查看详情-当天
      path: "/SreleaseDetailStaffReturn",
      name: "/SreleaseDetailStaffReturn",
      component: resolve =>
        require(["../views/mobile/SreleaseDetailStaffReturn.vue"], resolve)
    }
  ]
});
// router.beforeEach((to, from, next) => {
//   versionUpdate.isNewVersion();
// });

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js